"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import HtmlEmbed from "./webflow_modules/Embed/components/HtmlEmbed";

export function CardIconPet({}) {
  return (
    <Block
      className={"amenity---icon"}
      tag={"div"}
      // @ts-ignore - User-defined custom attribute(s)
      title={"EV Charging"}
    >
      <HtmlEmbed
        className={"html-embed-2"}
        content={
          '<svg viewBox="0 0 11 11" xmlns="http://www.w3.org/2000/svg" aria-labelledby="title">\n<title id="title" lang="en">This community is pet friendly.</title>\n<path d="M3.52425 0.624848C4.16342 0.532764 4.8405 1.23151 5.0355 2.19568C5.2305 3.15443 4.87842 4.01026 4.23925 4.10776C3.6055 4.20526 2.923 3.50651 2.72258 2.54235C2.52217 1.5836 2.88508 0.727764 3.52425 0.624848ZM7.39717 0.624848C8.04175 0.727764 8.39925 1.5836 8.20967 2.54235C8.00383 3.50651 7.32675 4.20526 6.68758 4.10776C6.043 4.01026 5.69092 3.15443 5.89133 2.19568C6.08633 1.23151 6.76342 0.532764 7.39717 0.624848ZM0.626333 3.11651C1.24383 2.8511 2.08342 3.33318 2.52217 4.17276C2.93383 5.0286 2.793 5.92776 2.18092 6.19318C1.56883 6.4586 0.734666 5.98193 0.306749 5.13151C-0.121167 4.2811 0.0304994 3.37651 0.626333 3.11651ZM10.3763 3.11651C10.9722 3.37651 11.1238 4.2811 10.6959 5.13151C10.268 5.98193 9.43383 6.4586 8.82175 6.19318C8.20967 5.92776 8.06883 5.0286 8.4805 4.17276C8.91925 3.33318 9.75883 2.8511 10.3763 3.11651ZM9.47175 8.95568C9.49342 9.46485 9.10342 10.0282 8.63758 10.2394C7.668 10.6836 6.51967 9.76276 5.44175 9.76276C4.36383 9.76276 3.20467 10.7215 2.25133 10.2394C1.70967 9.97401 1.33592 9.26985 1.40633 8.68485C1.50383 7.87776 2.47342 7.44443 3.04758 6.85401C3.81133 6.09026 4.353 4.65485 5.44175 4.65485C6.52508 4.65485 7.09925 6.0686 7.8305 6.85401C8.43175 7.51485 9.43383 8.07276 9.47175 8.95568Z" fill="currentColor"/>\n</svg>'
        }
      />
    </Block>
  );
}
